module.exports = __webpack_public_path__ + "static/img/solution4.ec9beff.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/solution4.png
// module id = PYv9
// module chunks = 1